export function initHrefSingle(element: HTMLElement) {
    const href = element.dataset.href;
    const newTab = element.dataset.hrefNewtab !== undefined;
    element.addEventListener('click', () => {
        if (newTab) {
            window.open(href, '_blank').focus();
        } else {
            window.location.href = href;
        }

        element.querySelectorAll('a').forEach(a => a.addEventListener('click', e => e.stopPropagation()));
    });
}

export function initHrefs() {
    const hrefs = document.querySelectorAll<HTMLElement>('[data-href]');

    hrefs.forEach(element => {
        initHrefSingle(element);
    });
};